
































































import {Component, Prop} from "vue-property-decorator";
import WarehouseTable from "@/modules/warehouses/shared/components/WarehouseTable/index.vue";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {Site} from "@/interfaces/entity";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";

@Component({
    name: "SiteExcel",
    components: {LadingStatusLabel, WarehouseTable}
})
export default class extends mixins(CommonMixin) {
    @Prop({required: true, type: Array}) readonly sites!: Array<Site>;

    get weightDeliveryMain() {
        return this.sites[0]?.weightDeliveryMain || 0;
    }

    get weightDeliveryPlus() {
        return this.sites[0]?.weightDeliveryPlus || 0;
    }

    get weightReceiveMain() {
        return this.sites[0]?.weightReceiveMain || 0;
    }

    get weightReceivePlus() {
        return this.sites[0]?.weightReceivePlus || 0;
    }
}
